import React, { createContext, useContext, useState, ReactNode } from "react";
import { GoodsItem, GoodsGroup } from "../../types";

interface GoodsFocusContextType {
  focusedGoods: GoodsItem | null;
  setFocusedGoods: (goods: GoodsItem | null) => void;
  currentGroups: GoodsGroup[];
  setCurrentGroups: (group: GoodsGroup[]) => void;
  buyAgreement: string | null;
  setBuyAgreement: (agreement: string | null) => void;
  detailRule: string | null;
  setDetailRule: (rule: string | null) => void;
  credit: number | null;
  setCredit: (credit: number | null) => void;
  currentGoodsList: GoodsItem[];
  setCurrentGoodsList: (goodsList: GoodsItem[]) => void;
}

const GoodsFocusContext = createContext<GoodsFocusContextType | undefined>(
  undefined,
);

export const useGoodsFocus = () => {
  const context = useContext(GoodsFocusContext);
  if (!context) {
    throw new Error("useGoodsFocus must be used within a GoodsFocusProvider");
  }
  return context;
};

interface GoodsFocusProviderProps {
  children: ReactNode;
}

export const GoodsFocusProvider: React.FC<GoodsFocusProviderProps> = ({
  children,
}) => {
  const [focusedGoods, setFocusedGoods] = useState<GoodsItem | null>(null);
  const [currentGroups, setCurrentGroups] = useState<GoodsGroup[]>([]);
  const [buyAgreement, setBuyAgreement] = useState<string | null>(null);
  const [detailRule, setDetailRule] = useState<string | null>(null);
  const [credit, setCredit] = useState<number | null>(null);
  const [currentGoodsList, setCurrentGoodsList] = useState<GoodsItem[]>([]);

  return (
    <GoodsFocusContext.Provider
      value={{
        focusedGoods,
        setFocusedGoods,
        currentGroups,
        setCurrentGroups,
        buyAgreement,
        setBuyAgreement,
        detailRule,
        setDetailRule,
        credit,
        setCredit,
        currentGoodsList,
        setCurrentGoodsList,
      }}
    >
      {children}
    </GoodsFocusContext.Provider>
  );
};
